var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"footer",staticClass:"footer",class:{fixed: _vm.fixed}},[_c('p',{staticClass:"footer--location"},[_vm._v("12 rue mansart 75009 Paris")]),_vm._v(" "),_c('a',{staticClass:"footer--contact",attrs:{"href":"mailto:contact@jiaszeto.com"}},[_vm._v("contact@jiaszeto.com")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-344b3ae4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 51
// module chunks = 0